import MobileAppInstallBanner from './MobileAppInstallBanner';

export default MobileAppInstallBanner;
